// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-section.-section-ticker .card{border-radius:16px;overflow:hidden}.about-section .ticker{--gap:40px;align-items:center;animation:ticker 10s linear infinite;display:flex;font-size:24px;font-weight:700;gap:40px;gap:var(--gap);margin-left:0;position:relative;white-space:nowrap}.about-section .ticker .v-image{height:32px;width:32px}@keyframes ticker{0%{transform:translateX(0)}to{transform:translateX(calc(-50% + var(--gap)/2*-1))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
